import { restApi } from '../../../services/api';

const PATH = '/invites';

export const myNetworkInvitesSentRepository = () => {
  const getInvitesSent = () => restApi.get(`${PATH}?type=SENT`);
  const remove = (id: string) => restApi.delete(`${PATH}/${id}`);
  const updateMessage = (id: string, message: string) =>
    restApi.patch(`${PATH}/${id}`, { message });

  return {
    getInvitesSent,
    updateMessage,
    remove,
  };
};
